// src/modules/app-views/invoices/pages/Init/components/tableColumns/itemsCountColumn.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Typography } from 'antd';
import translateX from 'utils/translateX';

const { Text } = Typography;

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************

// Renders the items count column.
function itemsCountColumn(buildColumnProps, options = {}) {
  return {
    title: translateX('items'),
    dataIndex: 'items',
    ...buildColumnProps('items', { sort: true, search: false }),
    width: 70,
    align: 'center',
    render: (_, record) => {
      const count = record?.items?.length || 0;
      return <Text>{count}</Text>;
    },
  };
}

export default itemsCountColumn;
